import React, { useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  FecthUserList,
  GetUserListColumns,
} from "../../helpers/users/FetchUserList";
import { checkPermissionStatus, getSubdomain } from "helpers/utils";

import user_pic from "../../assets/images/pic-change.png";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import job from "../../assets/images/icon/job.svg";
import email from "../../assets/images/icon/email.svg";
import location from "../../assets/images/icon/location.svg";
import account from "../../assets/images/icon/account.svg";
import mobile from "../../assets/images/icon/mobile.svg";
import pencil from "../../assets/images/icon/pencil.svg";
import time_slot from "../../assets/images/time-slot-card.webp";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { useTranslation } from "react-i18next";
import { getUserInfo } from "helpers/authHelper";
import { toast } from "react-toastify";



function UserList(props) {
  const { t } = useTranslation();
  const userInfo = getUserInfo();
  let columns = GetUserListColumns();
  let { userList: users, isLoading, error } = FecthUserList();

  useEffect(() => {
    document.title = "NeuroTal - User List";
  }, []);

  

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Profile.Showing rows`, { from, to, size })}
    </span>
  );
  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "Next page",
    prePageTitle: "Pre page",
    firstPageTitle:"First page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  console.log(userInfo,"userInfo")

  if (!checkPermissionStatus("user-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`Profile.Access Denied`)}</h4>
      </div>
    );
  }

  return (
    <>
      <div className="page-content departmentpage">
        <Container fluid>
          <div className="joblist-container create-vacancy">
            <Row className="align-items-center  py-2 pt-0">
              <Col lg="6" md="6" className="Joblist-column">
                <Link to="/">
                  <h5 className="text-uppercase heading-one">
                    <img src={arrow_btn} alt="arrow_btn" />
                    {t(`Profile.User Details`)}
                  </h5>
                </Link>
              </Col>
            </Row>
          </div>
          <div className="outerTab-box-wrapper below-vacancy  ui-modification">
            <div className="user-details-cards cards-section cadidate-details">
              <div className="user-details-pic">
                <img src={user_pic} alt="" />
              </div>

              <div className="user-details-content w-100">
                <Link to={`/edit-user/${userInfo?.id}`}>
                  <div className="edit-pen-details">
                    <span>
                      <img src={pencil} alt="pencil/" />
                    </span>
                    <h6>{t(`Profile.Edit Profile`)}</h6>
                  </div>
                </Link>

                <div className="user-details-card">
                  <h4>{userInfo?.name}</h4>
                </div>

                <div class="card-table-details w-100">
                  <div class="personalInfo-details mt-3 w-100">
                    <div class="personal-info">
                      <span>
                        <img src={email} alt="email" />
                      </span>
                      <div class="perosonal-card-info">
                        <h4>{t(`Profile.Email Id`)}:</h4>
                        <span className="text-transform-none">
                          {userInfo?.email}
                        </span>
                      </div>
                    </div>
                    <div class="personal-info">
                      <span>
                        <img src={mobile} alt="email" />
                      </span>
                      <div class="perosonal-card-info">
                        <h4>{t(`Profile.Mobile No`)}:</h4>
                        <span>
                          <a href="tel:9898977777">{userInfo?.phone}</a>
                        </span>
                      </div>
                    </div>
                    <div class="personal-info superadmin">
                      <span>
                        <img src={job} alt="email" />
                      </span>
                      <div class="perosonal-card-info">
                        <h4>{t(`Profile.Role`)}</h4>
                        <span> {userInfo?.role_name}</span>
                      </div>
                    </div>
                    <div class="personal-info">
                      <span>
                        <img src={account} alt="email" />
                      </span>
                      <div class="perosonal-card-info">
                        <h4>{t(`Profile.user_name`)}</h4>
                        <span>{userInfo?.username}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {getSubdomain() !== "mahindra" && (
              <div className="interview-slot">
                <h5>
                  {t(`Profile.Add availability for Set Up an Interview Slot`)}
                </h5>
                <div className="btn-cla">
                  <Link to="/edit-user/9" className="btn btn-primary">
                    + {t(`Profile.Add Availability`)}
                  </Link>
                </div>

                <img src={time_slot} alt="" className="interview-img" />
              </div>
            )}
          </div>

          <div className="joblist-container userlist  userlist-cards">
            <Row className="mb-3 align-items-center  py-2">
              <Col lg="6" md="6">
                <h5 className="text-uppercase heading-one">
                  {t(`Profile.Users List`)}
                </h5>
              </Col>

              <Col lg="6" md="6">
                <div className="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
                  <Link to="/create-user" className="btn btn-primary ms-auto">
                    + {t(`Profile.Create User`)}
                  </Link>

                  <div className="tale-text right-panel ms-0">
                    <button
                      className="button left"
                      onClick={() => handleScroll("left")}
                      data-tooltip={t(`Profile.Scroll Left`)}
                    >
                      <img src={right_arrow} alt="right-arrow" />
                    </button>
                    <button
                      className="button right"
                      onClick={() => handleScroll("right")}
                      data-tooltip={t(`Profile.Scroll Right`)}
                    >
                      <img src={right_arrow} alt="right-arrow" />
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <div className="outerTab-box-wrapper below-vacancy">
            <Row>
              <div>
                {error === null ? (
                  users.length > 0 ? (
                    <>
                      <div className="tabel-application tabel-application-auto table-responsive white-space-row">
                        <div className="timeto-hire-card userlist  userlist-row">
                          <ToolkitProvider
                            keyField="name"
                            data={users}
                            columns={columns}
                          >
                            {props => (
                              <>
                                <div className="table-custome-class range-custome">
                                  <>
                                    <div className="scroll-container">
                                      <div className="table-pending-list">
                                        <div
                                          className="table-wrapper"
                                          ref={tableWrapperRef}
                                        >
                                          <BootstrapTable
                                            {...props.baseProps}
                                            options={options}
                                            classes={
                                              "table align-middle table-hover table-bordered"
                                            }
                                            bordered={true}
                                            striped={true}
                                            responsive
                                            pagination={paginationFactory(
                                              options
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                </div>
                              </>
                            )}
                          </ToolkitProvider>
                        </div>
                      </div>
                    </>
                  ) : (
                    <p
                      style={{
                        textAlign: "center",
                        color: "#888",
                        fontWeight: "normal",
                        fontSize: "18px",
                      }}
                    >
                      {t(`Profile.No Users Available`)}
                    </p>
                  )
                ) : (
                  <p
                    style={{
                      textAlign: "center",
                      color: "#888",
                      fontWeight: "normal",
                      fontSize: "18px",
                    }}
                  >
                    {error}
                  </p>
                )}
              </div>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
}

export default UserList;
